require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('npzhoofdpagina', undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/akkoordgeven/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/akkoordgeven/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/akkoordgeven/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('gegevenszorgverleners').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('gegevenszorgverleners').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad76d327dd3d182c19f36f96773b0ab3', (await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/akkoordgeven/components/ad76d327dd3d182c19f36f96773b0ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad76d327dd3d182c19f36f96773b0ab3', (await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/akkoordgeven/components/4c6ca47f53d7a3569ceafd3cd223988c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var organisatie, listlocations, list, location2, item, org;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('a67cbb11c14886111667b83e0992937c', 51.958901, 5.8435647);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('421cafe5eb8b469744ae8d65e74595f1', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevenszorgverleners','whereClause': 'pzgegevensdelen=\'Ja\'','sortBy': 'naam DESC' })));
  org = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause('pzgegevensdelen=\'Ja\'').setProperties('organisatie').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'organisatie'));})));
  organisatie = org.join('\',\'');
  location2 = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause('pzgegevensdelen=\'Ja\'').setProperties('pzwoonplaatsen').setGroupBy('pzwoonplaatsen').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'pzwoonplaatsen'));})));
  list = location2.join(',');
  listlocations = list.split(',');
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('a67cbb11c14886111667b83e0992937c', ((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['woonplaats IN (\'',listlocations.join('\',\''),'\')'].join(''))).setPageSize(100))).map(item => item['location'])));
  ___arguments.context.pageData['marker'] = ((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['woonplaats IN (\'',listlocations.join('\',\''),'\')'].join(''))).setPageSize(100))).map(item => item['location']));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Claudia van Bochove' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'lorionpzgldbhrlieke') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',organisatie,'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['filternaam'] = '%';
  ___arguments.context.pageData['filterorganisatie'] = '%';
  ___arguments.context.pageData['filterrollentaken'] = '%';
  ___arguments.context.pageData['filterwoonplaats'] = '%';
  ___arguments.context.pageData['filteropleiding'] = '%';
  ___arguments.context.pageData['filterlijnwerkzaam'] = '%';
  ___arguments.context.pageData['filterrollentaken'] = '%';
  ___arguments.context.pageData['filterwoonplaats'] = '%';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/dashboard/components/94fdd2cf2b6f558a4ad570ad9c82e794/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var organisatie, listlocations, list, location2, item, org;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('421cafe5eb8b469744ae8d65e74595f1', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevenszorgverleners','whereClause': (['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join('')),'sortBy': 'naam DESC' })));
  org = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('organisatie').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'organisatie'));})));
  organisatie = org.join('\',\'');
  location2 = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('pzwoonplaatsen').setGroupBy('pzwoonplaatsen').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'pzwoonplaatsen'));})));
  list = location2.join(',');
  listlocations = list.split(',');
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('a67cbb11c14886111667b83e0992937c', ((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['woonplaats IN (\'',listlocations.join('\',\''),'\')'].join(''))).setPageSize(100))).map(item => item['location'])));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Bo van Aalst') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',organisatie,'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('naam').setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dashboard/components/2114819b9f1f4d46f37edeaa7ee8b0aa/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('organisatie').setSortBy('organisatie ASC').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'organisatie')),'label': (getObjectProperty(item, 'organisatie')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var organisatie, listlocations, list, location2, item, org;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('421cafe5eb8b469744ae8d65e74595f1', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevenszorgverleners','whereClause': (['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join('')),'sortBy': 'naam DESC' })));
  org = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('organisatie').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'organisatie'));})));
  organisatie = org.join('\',\'');
  location2 = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('pzwoonplaatsen').setGroupBy('pzwoonplaatsen').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'pzwoonplaatsen'));})));
  list = location2.join(',');
  listlocations = list.split(',');
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('a67cbb11c14886111667b83e0992937c', ((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['woonplaats IN (\'',listlocations.join('\',\''),'\')'].join(''))).setPageSize(100))).map(item => item['location'])));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Bo van Aalst') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',organisatie,'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')) })));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dashboard/components/bedf95c97c57aad95d1f337977743cb7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var organisatie, listlocations, list, location2, item, org;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('421cafe5eb8b469744ae8d65e74595f1', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevenszorgverleners','whereClause': (['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join('')),'sortBy': 'naam DESC' })));
  org = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('organisatie').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'organisatie'));})));
  organisatie = org.join('\',\'');
  location2 = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('pzwoonplaatsen').setGroupBy('pzwoonplaatsen').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'pzwoonplaatsen'));})));
  list = location2.join(',');
  listlocations = list.split(',');
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('a67cbb11c14886111667b83e0992937c', ((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['woonplaats IN (\'',listlocations.join('\',\''),'\')'].join(''))).setPageSize(100))).map(item => item['location'])));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Bo van Aalst') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',organisatie,'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')) })));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dashboard/components/84b5c604a674409d110b4c2a7e861b3d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var organisatie, org, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('421cafe5eb8b469744ae8d65e74595f1', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevenszorgverleners','whereClause': (['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join('')),'sortBy': 'naam DESC' })));
  org = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('organisatie').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'organisatie'));})));
  organisatie = org.join('\',\'');
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('a67cbb11c14886111667b83e0992937c', ((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(item => item['location'])));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Bo van Aalst') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',organisatie,'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/54532af9da7f0fc2560741d65536180c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var organisatie, org, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterorganisatie'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('421cafe5eb8b469744ae8d65e74595f1', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevenszorgverleners','whereClause': (['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join('')),'sortBy': 'naam DESC' })));
  org = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('organisatie').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'organisatie'));})));
  organisatie = org.join('\',\'');
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('a67cbb11c14886111667b83e0992937c', ((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(item => item['location'])));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Bo van Aalst') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',organisatie,'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')) })));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/619e3ada4771d698a8886c1367eae011/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var organisatie, org, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filteropleiding'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('421cafe5eb8b469744ae8d65e74595f1', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevenszorgverleners','whereClause': (['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join('')),'sortBy': 'naam DESC' })));
  org = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('organisatie').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'organisatie'));})));
  organisatie = org.join('\',\'');
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('a67cbb11c14886111667b83e0992937c', ((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(item => item['location'])));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Bo van Aalst') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',organisatie,'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')) })));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/202e9005268b8e424c6bc445e394d4a1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var organisatie, list, listlocations, location2, item, org;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('421cafe5eb8b469744ae8d65e74595f1', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevenszorgverleners','whereClause': (['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join('')),'sortBy': 'naam DESC' })));
  org = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('organisatie').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'organisatie'));})));
  organisatie = org.join('\',\'');
  location2 = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('pzwoonplaatsen').setGroupBy('pzwoonplaatsen').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'pzwoonplaatsen'));})));
  list = location2.join(',');
  listlocations = list.split(',');
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('a67cbb11c14886111667b83e0992937c', ((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['woonplaats=\'',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'\''].join(''))).setPageSize(100))).map(item => item['location'])));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Bo van Aalst') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',organisatie,'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')) })));
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setProperties('woonplaats').setSortBy('woonplaats ASC').setGroupBy('woonplaats').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'woonplaats')),'label': (getObjectProperty(item, 'woonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dashboard/components/0e32d349f64f89c6a89d50158e2758c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var organisatie, org, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterwoonplaats'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('421cafe5eb8b469744ae8d65e74595f1', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevenszorgverleners','whereClause': (['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join('')),'sortBy': 'naam DESC' })));
  org = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND pzgevolgdeopleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('organisatie').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'organisatie'));})));
  organisatie = org.join('\',\'');
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('a67cbb11c14886111667b83e0992937c', ((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(item => item['location'])));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Bo van Aalst') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',organisatie,'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')) })));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/76ea3f1dd5d2f8788b828bbcd059f05a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var organisatie, listlocations, list, location2, item, org;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('421cafe5eb8b469744ae8d65e74595f1', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevenszorgverleners','whereClause': (['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join('')),'sortBy': 'naam DESC' })));
  org = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('organisatie').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'organisatie'));})));
  organisatie = org.join('\',\'');
  location2 = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('pzwoonplaatsen').setGroupBy('pzwoonplaatsen').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'pzwoonplaatsen'));})));
  list = location2.join(',');
  listlocations = list.split(',');
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('a67cbb11c14886111667b83e0992937c', ((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['woonplaats IN (\'',listlocations.join('\',\''),'\')'].join(''))).setPageSize(100))).map(item => item['location'])));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Bo van Aalst') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',organisatie,'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')) })));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dashboard/components/44a1b04d6bcae445d18403eba5d8166d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var organisatie, org, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterlijnwerkzaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('421cafe5eb8b469744ae8d65e74595f1', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevenszorgverleners','whereClause': (['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join('')),'sortBy': 'naam DESC' })));
  org = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('organisatie').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'organisatie'));})));
  organisatie = org.join('\',\'');
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('a67cbb11c14886111667b83e0992937c', ((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(item => item['location'])));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Bo van Aalst') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',organisatie,'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')) })));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/1e568ffb36e2a02325f9b345bef68d05/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var organisatie, listlocations, list, location2, item, org;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('421cafe5eb8b469744ae8d65e74595f1', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevenszorgverleners','whereClause': (['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join('')),'sortBy': 'naam DESC' })));
  org = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('organisatie').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'organisatie'));})));
  organisatie = org.join('\',\'');
  location2 = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('pzwoonplaatsen').setGroupBy('pzwoonplaatsen').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'pzwoonplaatsen'));})));
  list = location2.join(',');
  listlocations = list.split(',');
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('a67cbb11c14886111667b83e0992937c', ((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['woonplaats IN (\'',listlocations.join('\',\''),'\')'].join(''))).setPageSize(100))).map(item => item['location'])));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Bo van Aalst') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',organisatie,'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')) })));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dashboard/components/4ca991097e2de67b47836234656a30f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var organisatie, org, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterrollentaken'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('421cafe5eb8b469744ae8d65e74595f1', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevenszorgverleners','whereClause': (['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join('')),'sortBy': 'naam DESC' })));
  org = (await Promise.all((await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND opleidingen LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filteropleiding')),'%\' AND lijnenwerkzaam LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterlijnwerkzaam')),'%\' AND rollentaken LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterrollentaken')),'%\' AND pzwoonplaatsen LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'filterwoonplaats')),'%\' AND pzgegevensdelen=\'Ja\''].join(''))).setProperties('organisatie').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'organisatie'));})));
  organisatie = org.join('\',\'');
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('a67cbb11c14886111667b83e0992937c', ((await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(item => item['location'])));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Bo van Aalst') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',organisatie,'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')),'sortBy': 'organisatie DESC' })));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('753537cea5d76db36d01dd599779f4b7', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gegevensorganisaties','whereClause': (['organisatie IN (\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\')',' AND toestemminggegevensdelen=\'Ja\''].join('')) })));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/712ac7e207f37a14277cccc7563f634d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'gegevenszorgverlenerpalliatievezorg.csv','tableName': 'gegevenszorgverleners','tableOptions': ({ 'pageSize': 4000,'where': 'pzgegevensdelen=\'Ja\'','groupBy': undefined,'properties': ['naam', 'organisatie', 'functie', 'pzspecifiekeexpertise', 'telefoonnummer', 'email', 'rollentaken', 'rollentakenanders', 'pzopleidingsniveau', 'pzgevolgdeopleidingen', 'pzaantaljaarervaring', 'pzcaseload', 'consultatie', 'lijnenwerkzaam', 'pzwoonplaatsen', 'pzconsultenvergoed', 'pztoelichtingconsultenvergoed'],'columnsMapping': ({ 'naam': 'Naam','organisatie': 'Organisatie','functie': 'Functie','pzspecifiekeexpertise': 'Expertise','telefoonnummer': 'Telefoonnummer','email': 'Emailadres','rollentaken': 'Rollen/taken','rollentakenanders': 'Evt. toelichting bij \'Anders\' rollen/taken','pzopleidingsniveau': 'Opleidingsniveau','pzgevolgdeopleidingen': 'Gevolgde opleidingen','pzaantaljaarervaring': 'Aantal jaar ervaring','pzcaseload': 'Caseload','consultatie': 'Consultatie intern/extern','lijnenwerkzaam': 'In welke lijn(en) werkzaam?','pzwoonplaatsen': 'Werkgebied','pzconsultenvergoed': 'Consulten vergoed?','pztoelichtingconsultenvergoed': 'Toelichting vergoeding consulten' }) }),'csvOptions': ({ 'header': true,'columns': ['Naam', 'Organisatie', 'Functie', 'Expertise', 'Telefoonnummer', 'Emailadres', 'Rollen/taken', 'Evt. toelichting bij \'Anders\' rollen/taken', 'Opleidingsniveau', 'Gevolgde opleidingen', 'Aantal jaar ervaring', 'Caseload', 'Consultatie intern/extern', 'In welke lijn(en) werkzaam?', 'Werkgebied', 'Consulten vergoed?', 'Toelichting vergoeding consulten'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvFile, true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Claudia van Bochove' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'lorionpzgldbhrlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dashboard/components/7fa1fe8919784fc3f1db43789426d27f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'gegevensorganisatiepalliatievezorg.csv','tableName': 'gegevensorganisaties','tableOptions': ({ 'pageSize': 4000,'where': 'toestemminggegevensdelen=\'Ja\'','groupBy': undefined,'properties': ['organisatie', 'strategischbeleidsplanaanwezig', 'strategischbeleidsplantoelichting', 'strategischbeleidsplanscholing', 'strategischbeleidsplanscholingtoelichting', 'relevanteprojectenpz', 'geaccrediteerdescholingenaanbod', 'geaccrediteerdescholingenwelke', 'zelfevaluatieuitgevoerd', 'zelfevaluatietoelichting', 'contactgegevensinkoop'],'columnsMapping': ({ 'organisatie': 'Organisatie','strategischbeleidsplanaanwezig': 'Is er een strategisch beleidsplan?','strategischbeleidsplantoelichting': 'Toelichting t.a.v. beleid palliatieve zorg','strategischbeleidsplanscholing': 'Is er beleid t.a.v. scholing?','strategischbeleidsplanscholingtoelichting': 'Toelichting t.a.v. beleid scholing','relevanteprojectenpz': 'Zijn er relevante projecten palliatieve zorg in 2022?','geaccrediteerdescholingenaanbod': 'Worden er geaccrediteerde scholingen aangeboden?','geaccrediteerdescholingenwelke': 'Welke geaccrediteerde scholingen worden aangeboden?','zelfevaluatieuitgevoerd': 'Wordt de Zelfevaluatie palliatieve zorg uitgevoerd?','zelfevaluatietoelichting': 'Toelichting zelfevaluatie','contactgegevensinkoop': 'Contactgegevens medewerker die zorg inkoopt' }) }),'csvOptions': ({ 'header': true,'columns': ['Organisatie', 'Is er een strategisch beleidsplan?', 'Toelichting t.a.v. beleid palliatieve zorg', 'Is er beleid t.a.v. scholing?', 'Toelichting t.a.v. beleid scholing', 'Zijn er relevante projecten palliatieve zorg in 2022?', 'Worden er geaccrediteerde scholingen aangeboden?', 'Welke geaccrediteerde scholingen worden aangeboden?', 'Wordt de Zelfevaluatie palliatieve zorg uitgevoerd?', 'Toelichting zelfevaluatie', 'Contactgegevens medewerker die zorg inkoopt'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvFile, true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Claudia van Bochove' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'lorionpzgldbhrlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dashboard/components/04b6662a80f9a39fce3d0d4266143c7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1SbmR5RIdy70n4XB7sBobEAZNae493TGIWReCLM4bbSw/edit?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'info@praktijk-bo.nl' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Loriobhr' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dashboard/components/7434e4712083173c6bb6e168c0b5f79d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1SbmR5RIdy70n4XB7sBobEAZNae493TGIWReCLM4bbSw/edit?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'info@praktijk-bo.nl' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Loriobhr' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('npzhoofdpagina', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('npzhoofdpagina', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/5a1d2aab192247abfb9292919a52d0f6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join(''))).setProperties(['naam', 'organisatie', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/gebruikersbeheer/components/dd2ac4efbecb1abe55a608d2323a9f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0dcd100a43f8da29832aea72b61d49cc')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/bfad8b5160a8b3e6253374a4c7ba2ce6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);
  ___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829')['selected'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/0ab633ae17a6e5765fa8cd8a0fd2bf63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('userdeactiveren', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`naamdeactiveren`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),[`organisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'organisatie')) }), undefined);
  (function (message) { alert(message) })((['Het verzoek tot het deactiveren van user ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),' is verzonden. Wij zullen deze gebruiker zo snel mogelijk op inactief zetten. Tot die tijd vindt u deze gebruiker nog in onderstaande lijst.'].join('')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/87b21c497cf55673c52611530531b85e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'userStatus')) == 'ENABLED' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/7836af74b96eaf0fc8f1b77d91fd4125/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND GV LIKE \'GV%\''].join(''))).setProperties('dashboardnaam').setSortBy('dashboardnaam ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dashboardnaam')),'label': (getObjectProperty(item, 'dashboardnaam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/38b45228c9ab1108f4319b04e5df558f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f24bb6b6ee8444046dfd4b245e7a6503')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/d0ab53412e941c4725f9135d79ebe1ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dashboardnaam')) == null) {
    (function (message) { alert(message) })('Er is geen dashboardnaam geselecteerd.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('dashboardnaamopvragen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'regiogv': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'email': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'centraname': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'dashboardnaam': (getObjectProperty(___arguments.context.pageData, 'dashboardnaam')) }), undefined);
    (function (message) { alert(message) })('Het verzoek is verzonden. U ontvangt zo snel mogelijk bericht.');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/4ecb878544048e22f147a48a121282aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'gv')) == null) {
    (function (message) { alert(message) })('De rol dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('De naam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Het emailadres dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'organisatie')) == null) {
    (function (message) { alert(message) })('De organisatie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0972e5824ad68dc30fb528fe7d2eb9a')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'regiogv')) == null) {
    (function (message) { alert(message) })('De regio dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwplichtig')) == null) {
    (function (message) { alert(message) })('De btw plicht dient ingevuld te worden');
  } else {
    await Backendless.UserService.register( new Backendless.User({ 'centraname': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'username': String(new Date()),'password': 'CVL2022isBegonnen!','GV': (getObjectProperty(___arguments.context.pageData, 'gv')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')),'regiogv': (getObjectProperty(___arguments.context.pageData, 'regiogv')),'btwplichtig': (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),'btwinclconsulten': (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten')),'btwinclgroepsconsulten': (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten')),'btwinclscholing': (getObjectProperty(___arguments.context.pageData, 'btwinclscholing')),'btwinclcoaching': (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching')),'btwinclmdopatz': (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('newuseraanmelding', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`naamnewuser`]: (getObjectProperty(___arguments.context.pageData, 'naam')) }), undefined);
    (function (message) { alert(message) })('De gebruiker is aangemeld. Wij zullen zo snel mogelijk een account voor de gebruiker aanmaken en hem of haar een mail sturen met de benodigde informatie.');
    ___arguments.context.pageData['gv'] = null;
    ___arguments.context.pageData['naam'] = null;
    ___arguments.context.pageData['email'] = null;
    ___arguments.context.pageData['organisatie'] = null;
    ___arguments.context.pageData['regiogv'] = null;
    ___arguments.context.pageData['btwplichtig'] = false;
    ___arguments.context.pageData['btwplichtigselect'] = false;
    ___arguments.context.pageData['btwinclconsulten'] = false;
    ___arguments.context.pageData['btwinclconsultenselect'] = false;
    ___arguments.context.pageData['btwinclgroepsconsulten'] = false;
    ___arguments.context.pageData['btwinclgroepsconsultenselect'] = false;
    ___arguments.context.pageData['btwinclmdopatz'] = false;
    ___arguments.context.pageData['btwinclmdopatzselect'] = false;
    ___arguments.context.pageData['btwinclscholing'] = false;
    ___arguments.context.pageData['btwinclscholingselect'] = false;
    ___arguments.context.pageData['btwinclcoaching'] = false;
    ___arguments.context.pageData['btwinclcoachingselect'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/e0972e5824ad68dc30fb528fe7d2eb9a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('regio').setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')),'label': (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/beb80b15f265c7764dc6ae77491c7109/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclscholingselect')) == true) {
    ___arguments.context.pageData['btwinclscholing'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclscholingselect')) == false) {
    ___arguments.context.pageData['btwinclscholing'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/85afad1323a559a247c7d27e5a26e7c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwplichtigselect')) == true) {
    ___arguments.context.pageData['btwplichtig'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwplichtigselect')) == false) {
    ___arguments.context.pageData['btwplichtig'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/45f607e2ccd2bfa5f3f27eb7785cd294/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclconsultenselect')) == true) {
    ___arguments.context.pageData['btwinclconsulten'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclconsultenselect')) == false) {
    ___arguments.context.pageData['btwinclconsulten'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/cd95b1a4af05c934e2bda1e92be60f47/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsultenselect')) == true) {
    ___arguments.context.pageData['btwinclgroepsconsulten'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsultenselect')) == false) {
    ___arguments.context.pageData['btwinclgroepsconsulten'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/529a64226faf1bd297452bb48e4e1226/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclcoachingselect')) == true) {
    ___arguments.context.pageData['btwinclcoaching'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclcoachingselect')) == false) {
    ___arguments.context.pageData['btwinclcoaching'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/cc464e9ed7efa588fd3aa1014bc49261/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclmdopatzselect')) == true) {
    ___arguments.context.pageData['btwinclmdopatz'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclmdopatzselect')) == false) {
    ___arguments.context.pageData['btwinclmdopatz'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join(''))).setProperties(['naam', 'organisatie', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/gebruikersbeheer/components/e031c83c1f6df2a433fe0185674839c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plgegevensgv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/736c89422ff2f8161ec73926b835933d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/cea9d95123a6fa28106de5a1f4875142/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/726d8f6221befee38d376c1d9434d3be/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/bdc9b7aea44c1baad0228c23722400b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/9b9d6494a40e5b2eba2828497fa6f7d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/d54d70db830f71c83111b66fcc5219f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/64b7288d8b58a322ef3183993b045f47/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/30e35eb2b337e024f2ba6312b8eaddcc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join(''))).setProperties(['naam', 'organisatie', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/187bbb778f8fa873a2435f2662487913/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join(''))).setProperties(['naam', 'organisatie', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/84a3b24178d6b4bcf1f651b7cd1ac09e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join(''))).setProperties(['naam', 'organisatie', 'lastLogin', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/a3ad098f83618ecb6548df8dacb7e475/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin')) == null) {
    text = null;
  } else {
    text = (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['isPasswordVisible'] = false;
  ___arguments.context.pageData['qrURL'] = null;
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('927c9caef221532a3a695d8ca4ded5cb')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inlogpagina/components/db5546014b7940ad8771a98d85f83036/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, transactionId, totpQR_Path, enableResult, secret;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}

/**
 * Describe this function...
 */
async function enable2FA() {
  enableResult = (await Backendless.Request.put(`${Backendless.appPath}/services/TOTP/enable2fa`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  totpQR_Path = (getObjectProperty(enableResult, 'totpQR_Path'));
  secret = (getObjectProperty(enableResult, 'secret'));
}


  try {
    await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'password')), false  );
    ___arguments.context.pageData['transactionId'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'transactionId'));
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'totpAuthEnabled')) == false) {
      await enable2FA();
      ___arguments.context.pageData['qrURL'] = ([(Backendless.appPath),'/files/',totpQR_Path].join(''));
      transactionId = (getObjectProperty((await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'password')), false  )), 'transactionId'));
      ___arguments.context.pageData['transactionId'] = transactionId;
    }

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 3033) {
    } else if ((getObjectProperty(error, 'code')) == 3003) {
      await setError((new Error('Gebruikersnaam en/of wachtwoord niet correct')));
    } else if ((getObjectProperty(error, 'code')) == 3036) {
      await setError((new Error('Uw account is geblokkeerd vanwege te veel mislukte aanmeldingen. Uw account zal na 24 uur weer toegankelijk zijn. Indien u eerder weer toegang wilt hebben neem dan contact op met info@lorio.nl')));
    } else {
      await setError(error);
    }

  } finally {
    if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'transactionId')).length) {
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cfb9adb26e7ccf1f942c0c492bdb4a98', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dfb563ff8336dc7fa902188371b71cd2', true);
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('999392c99779a94df0a6d85ddf3f4546')));
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/6d7b09fc8c04707fa6291e69b80c05d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')) == null) {
    (function (message) { alert(message) })('Vul je gebruikersnaam in om het wachtwoord te resetten.');
  } else {
    (function (message) { alert(message) })('Als de opgegeven gebruikersnaam bekend is, is er een e-mail verstuurd met een link om het wachtwoord te resetten.');
    await Backendless.Request.post(`${Backendless.appPath}/services/restorepassword/restorepassword`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username'))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/4eee7d87ea27420d1c9a2062870f0bfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isPasswordVisible'] = (!(getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4edd272bd7fb7f6f22eae3525232662'))['type'] = ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) ? 'input' : 'password');

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4eee7d87ea27420d1c9a2062870f0bfd'))['color'] = '#a1ae5d';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4eee7d87ea27420d1c9a2062870f0bfd'))['color'] = '#275536';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/31d10eed73315da80426fdb33572b8e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85dae34486144e2efa2d934bfdddb172', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8198ecaa1ac851aaab6202ce8432307', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/2aa494d42baf15e594c314b5ad0f60ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/b9f86c1955cc8dbb30a946c5e5a4eb13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isPasswordVisible'] = (!(getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb324748a239861f21fe07e5bf7f021f'))['type'] = ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) ? 'input' : 'password');
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('551f38b57fa4edec805e96152809a677'))['type'] = ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) ? 'input' : 'password');

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b9f86c1955cc8dbb30a946c5e5a4eb13'))['color'] = '#61843D';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b9f86c1955cc8dbb30a946c5e5a4eb13'))['color'] = '#545C5C';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/543abce1789c1a1a3ccd2b4e3dc82c5e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newuser, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307')['statusmessage'] = '';
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'naam')) == null) {
    (function (message) { alert(message) })('De naam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'username')) == null) {
    (function (message) { alert(message) })('De gebruikersnaam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'email')) == null) {
    (function (message) { alert(message) })('De email dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'organisatie')) == null) {
    (function (message) { alert(message) })('De organisatie dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'password')) == null) {
    (function (message) { alert(message) })('Het eerste wachtwoord dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'password2')) == null) {
    (function (message) { alert(message) })('Het tweede wachtwoord dient ingevuld te worden');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'password')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'password2'))) {
      ___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307')['statusmessage'] = 'Wachtwoorden komen niet overeen.';
    } else {
      try {
        newuser = (await Backendless.UserService.register( new Backendless.User({ 'username': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'username')),'password': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'password')),'naam': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'naam')),'organisatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'organisatie')),'rol': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'rol')),'email': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'email')),'rolzorgverlener': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'rolzorgverlener')),'rolorganisatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307'), 'rolorganisatie')) }) ));

      } catch (error) {
        if ((getObjectProperty(error, 'code')) == 0) {
          ___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307')['statusmessage'] = 'De registratie is niet gelukt. De gebruikersnaam is al in gebruik of het wachtwoord voldoet niet aan de gevraagde vereisten ';
        }

      } finally {
        if ((JSON.stringify(newuser)) == null) {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c01ecb49b5e3cc27425490c46488d72a', false);
        } else {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c01ecb49b5e3cc27425490c46488d72a', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8198ecaa1ac851aaab6202ce8432307', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e4d66466ae1fb0df5f336ecf688cbb1', true);
        }

      }
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/7bc78a2a5587b8bdf81498a6a98198ab/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c8198ecaa1ac851aaab6202ce8432307')['rol'] = 'Zorgverlener';

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inlogpagina/components/96e304c426ee928a7133f2fa40a55fe6/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
      return 'Zorgverlener'

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/a3095e5a3e665b0ed3557ed2bbd17343/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
      return 'Organisatie'

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/1df148cead2bf39d47f928b2cfa5255d/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'qrURL'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/10e73f1e9463f59a254e6338d4097ac5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error2'] = error;
}


  try {
    await (async function(user, stayLoggedIn) {
    	Backendless.Users.setCurrentUser(user, stayLoggedIn)
    })((await Backendless.Request.post(`${Backendless.appPath}/services/TOTP/auth`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': (Backendless.getCurrentUserToken()) }})).send({ 'transactionId': (getObjectProperty(___arguments.context.pageData, 'transactionId')),'code': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'mfawachtwoord')) })), false);

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 0) {
      await setError((new Error('De code is niet correct, probeer opnieuw')));
    } else {
      await setError(error);
    }

  } finally {
    if (await Backendless.UserService.isValidLogin()) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('npzhoofdpagina', undefined);
    } else {
      await setError((new Error('De code is niet correct, probeer opnieuw')));
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/d26a6258102dfddd95aa5918c746138a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1sI-5hz_16sYjyyK_JYeI6zrisGPKC0mh/view?usp=drive_link', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/4586d96b060ce949415d805fe17b520a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'qrURL')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/14edcdc102a13b52458f38f333c97d2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'qrURL')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/97d4d953cc4602c5181c04dd6952901c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/privacyverklaring/PrivacyverklaringLoriov1.5.pdf')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/e57f02cd5e86b614cbd5e1e568ede6ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/privacyverklaring/Gebruikersvoorwaarden%2BNPZ_Arnhem%2Bv1.0.pdf')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevens/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevens/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevens/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('gegevenszorgverleners').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('gegevenszorgverleners').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad76d327dd3d182c19f36f96773b0ab3', (await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/mijngegevens/components/ad76d327dd3d182c19f36f96773b0ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad76d327dd3d182c19f36f96773b0ab3', (await Backendless.Data.of('gegevenszorgverleners').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/5b2a824695749c17cb4da796cdfcecf5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'naam': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/f5596b12de2bd03f1ed94a43ef1138dd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'email': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/2adafcd487e2cf4a306d6bb893179bfe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'telefoonnummer': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/89463f99f17b52ab395fcf2b1ffdcfec/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'toelichtingrollentaken': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/40a1d6a3f2f4dd0959726d1c2e39496c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pztoelichtingconsultenvergoed': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/8d655a4c26f23e3710cb55bb933b1085/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzspecifiekeexpertise': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/2d782095807c88b326495a9b9c6fc12a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Consulent palliatieve zorg tPat (transmuraal consultatieteam)');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).splice((((getObjectProperty(___arguments.context.pageData, 'listrollentaken')).indexOf(' Consulent palliatieve zorg tPat (transmuraal consultatieteam)') + 1) - 1), 1);
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'rollentaken': (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).join(','),'rtconsulenttpat': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/90ec08977ded81c358b41d35502ee3ab/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Consulent palliatieve zorg bedside consultatie');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).splice((((getObjectProperty(___arguments.context.pageData, 'listrollentaken')).indexOf(' Consulent palliatieve zorg bedside consultatie') + 1) - 1), 1);
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'rollentaken': (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).join(','),'rtConsulentpalliatievezorgbedsideconsultatie': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/854c6cb7ec05ddde013e4b362cf83fac/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Consulent palliatieve zorg PaTz groep');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).splice((((getObjectProperty(___arguments.context.pageData, 'listrollentaken')).indexOf(' Consulent palliatieve zorg PaTz groep') + 1) - 1), 1);
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'rollentaken': (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).join(','),'rtConsulentpalliatievezorgPaTzgroep': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/9a18ff8e5b07d093d8fb9d68dcd2e391/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Consulent palliatieve zorg telefoondienst');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).splice((((getObjectProperty(___arguments.context.pageData, 'listrollentaken')).indexOf(' Consulent palliatieve zorg telefoondienst') + 1) - 1), 1);
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'rollentaken': (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).join(','),'rtConsulentpalliatievezorgtelefoondienst': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/2e91d90e94f536d19235db2add0ab676/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Opleidingen/deskundigheidsbevordering');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).splice((((getObjectProperty(___arguments.context.pageData, 'listrollentaken')).indexOf(' Opleidingen/deskundigheidsbevordering') + 1) - 1), 1);
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'rollentaken': (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).join(','),'rtOpleidingendeskundigheidsbevordering': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/a1d300eb94c128053226d10b80bc1f02/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Palliatieve zorg-coach');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).splice((((getObjectProperty(___arguments.context.pageData, 'listrollentaken')).indexOf(' Palliatieve zorg-coach') + 1) - 1), 1);
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'rollentaken': (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).join(','),'rtPalliatievezorgcoach': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/f80d45a1d525c97dab7967d577a1e4a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })(([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'rtAdviseurschap')),(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'rtBestuurslid')),(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'rtConsulentpalliatievezorgbedsideconsultatie')),(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'rtConsulentpalliatievezorgPaTzgroep')),(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'rtConsulentpalliatievezorgtelefoondienst')),(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'rtOpleidingendeskundigheidsbevordering')),(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'rtPalliatievezorgcoach'))].join('')));
  (function (message) { alert(message) })((getObjectProperty(___arguments.context.pageData, 'listrollentaken')));
  console.log(getObjectProperty(___arguments.context.pageData, 'listrollentaken'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevens/components/7dfdb91ffe9f468b95494926bebb4aac/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Adviseurschap');
    console.log(getObjectProperty(___arguments.context.pageData, 'listrollentaken'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).splice((((getObjectProperty(___arguments.context.pageData, 'listrollentaken')).indexOf(' Adviseurschap') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listrollentaken'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'rollentaken': (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).join(','),'rtAdviseurschap': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/c968728943775263279da639985a68c3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['listrollentaken'] = [];
  ___arguments.context.pageData['listlijn'] = [];
  ___arguments.context.pageData['listconsultatie'] = ((getObjectProperty(___arguments.context.dataModel, 'consultatie')).split(','));
  if ((getObjectProperty(___arguments.context.dataModel, 'rtAdviseurschap')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), 'Adviseurschap');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtbestuurslid')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), 'Bestuurslid');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtconsulenttpat')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), 'Consulent palliatieve zorg \'tPat (transmuraal consultatieteam)');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtConsulentpalliatievezorgbedsideconsultatie')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), 'Consulent palliatieve zorg bedside consultatie');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtConsulentpalliatievezorgPaTzgroep')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), 'Consulent palliatieve zorg PaTz groep');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtConsulentpalliatievezorgtelefoondienst')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), 'Consulent palliatieve zorg telefoondienst');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtOpleidingendeskundigheidsbevordering')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), 'Opleidingen/deskundigheidsbevordering');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtPalliatievezorgcoach')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), 'Palliatieve zorg-coach');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtanders')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), 'Anders');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'lijn1')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlijn')), '1ste lijn');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'lijn2')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlijn')), '2de lijn');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'lijn3')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlijn')), '2de lijn');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'lijn4')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlijn')), 'Transmuraal');
  }
  ___arguments.context.pageData['uploadwoonplaatsen'] = ((getObjectProperty(___arguments.context.dataModel, 'pzwoonplaatsen')).split(','));
  ___arguments.context.pageData['listwoonplaatsen'] = ((getObjectProperty(___arguments.context.dataModel, 'pzwoonplaatsen')).split(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/ffd54d4d7a844b475cd74cd48093f399/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlijn')), ' 1ste lijn');
    console.log(getObjectProperty(___arguments.context.pageData, 'listlijn'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listlijn')).splice((((getObjectProperty(___arguments.context.pageData, 'listlijn')).indexOf(' 1ste lijn') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listlijn'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'lijnenwerkzaam': (getObjectProperty(___arguments.context.pageData, 'listlijn')).join(','),'lijn1': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/c74c3a9ff74aaa1fdd62c258408f8da7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlijn')), ' 2de lijn');
    console.log(getObjectProperty(___arguments.context.pageData, 'listlijn'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listlijn')).splice((((getObjectProperty(___arguments.context.pageData, 'listlijn')).indexOf(' 2de lijn') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listlijn'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'lijnenwerkzaam': (getObjectProperty(___arguments.context.pageData, 'listlijn')).join(','),'lijn2': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/be9f0c961114bd1f5021d7be66566573/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlijn')), ' 3de lijn');
    console.log(getObjectProperty(___arguments.context.pageData, 'listlijn'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listlijn')).splice((((getObjectProperty(___arguments.context.pageData, 'listlijn')).indexOf(' 3de lijn') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listlijn'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'lijnenwerkzaam': (getObjectProperty(___arguments.context.pageData, 'listlijn')).join(','),'lijn3': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/e16667f7a33bce353b4f67035b5ae4b4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlijn')), ' Transmuraal');
    console.log(getObjectProperty(___arguments.context.pageData, 'listlijn'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listlijn')).splice((((getObjectProperty(___arguments.context.pageData, 'listlijn')).indexOf(' Transmuraal') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listlijn'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'lijnenwerkzaam': (getObjectProperty(___arguments.context.pageData, 'listlijn')).join(','),'lijn4': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/40d7f17da386ca94ee7f83d7e36e9c02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible'] = 'radio1';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevens/components/77d807f4810bac1486038bbf5bc59c5d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible')) == 'radio1') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'consultatie': 'Er is geen sprake van een consultatiefunctie' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible')) == 'radio2') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'consultatie': 'Intern (binnen de eigen organisatie)' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible')) == 'radio3') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'consultatie': 'Extern (buiten de eigen organisatie)' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible')) == 'radio4') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'consultatie': 'Intern/extern' }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/9eb19643bb573d79805557c6b44111fd/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'consultatie')) == 'Er is geen sprake van een consultatiefunctie') {
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible'] = 'radio1';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'consultatie')) == 'Intern (binnen de eigen organisatie)') {
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible'] = 'radio2';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'consultatie')) == 'Extern (buiten de eigen organisatie)') {
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible'] = 'radio3';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'consultatie')) == 'Intern/extern') {
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible'] = 'radio4';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/ed88af373a0b981a864dcfecae347227/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible2')) == 'radio5') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzconsultenvergoed': 'Ja' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible2')) == 'radio6') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzconsultenvergoed': 'Nee' }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/2e829f71913e515f2ffa8f7b62262811/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible3')) == 'radio7') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgegevensdelen': 'Ja' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible3')) == 'radio8') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgegevensdelen': 'Nee' }) );
    await Backendless.Messaging.sendEmail('NPZ Arnhem geen toestemming om gegevens te delen', new Backendless.Bodyparts({ htmlmessage: (['<body>','Hallo Lorio','<body><br>',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),' heeft geen toestemming gegeven om gegevens te delen.','<br>','Kan je controleren of dit de bedoeling is geweest?','<body><br>','Met vriendelijke groet,','<body><br>','Lorio'].join('')) }), ensureArray('info@lorio.nl'), undefined);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/05e17d7980c37b3ae03ffddb33e74c81/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio9') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': ' Kaderopleiding palliatieve zorg' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio10') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': ' Cardiff Palliative Medicine (post graduate)' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio11') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': ' Cursus palliatieve zorg voor medisch specialisten' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio12') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': ' (Post) HBO -opleiding palliatieve zorg' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio13') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': ' Opleiding (MSc) in een palliatieve zorgsetting' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio14') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': ' Basisscholing palliatieve zorg' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio13a') {
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': ' Palliatieve zorg voor verpleegkundigen (o.a. Erasmus MC)' }) );
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio15') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['pzgevolgdeopleidingen'] = null;
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': null }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/d58117738c426ca6237d3a216c7918e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': String('Anders - ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgevolgdeopleidingen')) }) );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio15')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/9579e0a948072adb5873615b40141b44/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'organisatie': ___arguments.value }) );
  await Backendless.Data.of('Users').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'organisatie': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/35ba6eb102d5a3f4d8ec54448b0779b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listwoonplaatsen')) == null) {
    ___arguments.context.pageData['listwoonplaatsen'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listwoonplaatsen')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('363eb25d9ea7d7496592ef01e66b38cd'), 'woonplaats')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listwoonplaatsen')).splice((((getObjectProperty(___arguments.context.pageData, 'listwoonplaatsen')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('363eb25d9ea7d7496592ef01e66b38cd'), 'woonplaats')) + 1) - 1), 1);
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzwoonplaatsen': (getObjectProperty(___arguments.context.pageData, 'listwoonplaatsen')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/be67b535e351f53576959648ec223e5b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Anders');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).splice((((getObjectProperty(___arguments.context.pageData, 'listrollentaken')).indexOf(' Anders') + 1) - 1), 1);
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['rollentakenanders'] = null;
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'rollentakenanders': null }) );
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'rollentaken': (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).join(','),'rtanders': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/cb78e48da95e697dc6c72fbe9184aed3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'rollentakenanders': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'rollentakenanders')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/bcb93c8d8fa7d80253c198f84cebba97/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = (getObjectProperty(___arguments.context.pageData, 'listconsultatie'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4ff2f93422bfb3c8e8b75c1cea0c7652'), 'consultatie')) == j) {
      ___arguments.context.getComponentDataStoreByUid('4ff2f93422bfb3c8e8b75c1cea0c7652')['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/dcfe78cef9067ed4d45a12f17d56b734/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listconsultatie')) == null) {
    ___arguments.context.pageData['listconsultatie'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listconsultatie')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('966c9bb6f51efb86a01f8fee77286d2f'), 'consultatie')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listconsultatie')).splice((((getObjectProperty(___arguments.context.pageData, 'listconsultatie')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('966c9bb6f51efb86a01f8fee77286d2f'), 'consultatie')) + 1) - 1), 1);
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'consultatie': (getObjectProperty(___arguments.context.pageData, 'listconsultatie')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/ca580a658c2b652707e47c7b6e23bd42/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Bestuurslid');
    console.log(getObjectProperty(___arguments.context.pageData, 'listrollentaken'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).splice((((getObjectProperty(___arguments.context.pageData, 'listrollentaken')).indexOf(' Bestuurslid') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listrollentaken'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'rollentaken': (getObjectProperty(___arguments.context.pageData, 'listrollentaken')).join(','),'rtbestuurslid': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/5abdc7981537c8df863d094869669f24/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['listfunctie'] = [];
  ___arguments.context.pageData['listrollentaken'] = [];
  ___arguments.context.pageData['listlijn'] = [];
  ___arguments.context.pageData['listopleidingen'] = [];
  if ((getObjectProperty(___arguments.context.dataModel, 'functiezorgcoordinator')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), 'Zorgcoördinator');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'functieconsulent')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), 'Consulent');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'functiegespecialiseerdverpleegkundige')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), 'Gespecialiseerd verpleegkundige');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'functieverpleegkundigspecialist')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), 'Verpleegkundig specialist');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'functiekaderarts')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), 'Kaderarts palliatieve zorg');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'functiespecialistouderengeneeskunde')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), 'Specialist ouderengeneeskunde');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'functieinternist')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), 'Internist');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'functieoncoloog')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), 'Oncoloog');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'functieklinischegeriater')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), 'Klinische geriater');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'functiegeestelijkverzorger')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), 'Geestelijk verzorger');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'functiepersoonlijkbegeleider')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), 'Persoonlijk begeleider');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtbestuurslid')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Bestuurslid');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtconsulenttpat')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Consulent palliatieve zorg \'tPat (transmuraal consultatieteam)');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtConsulentpalliatievezorgbedsideconsultatie')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Consulent palliatieve zorg bedside consultatie');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtConsulentpalliatievezorgPaTzgroep')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Consulent palliatieve zorg PaTz groep');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtConsulentpalliatievezorgtelefoondienst')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Consulent palliatieve zorg telefoondienst');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtOpleidingendeskundigheidsbevordering')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Opleidingen/deskundigheidsbevordering');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtPalliatievezorgcoach')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Palliatieve zorg-coach');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'rtanders')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listrollentaken')), ' Anders');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'lijn1')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlijn')), ' 1ste lijn');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'lijn2')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlijn')), ' 2de lijn');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'lijn3')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlijn')), ' 3de lijn');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'lijn4')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlijn')), ' Transmuraal');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'olbasisscholingpz')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' Basisscholing palliatieve zorg');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'olcardiffpalliativemedicine')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' Cardiff Palliative Medicine (post graduate)');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'olcursuspzvoormedischspecialisten')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' Cursus palliatieve zorg voor medisch specialisten');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'olkaderopleidingpz')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' Kaderopleiding palliatieve zorg');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'olineenpalliatievezorgsetting')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' Opleiding (MSc) in een palliatieve zorgsetting');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'olpzvoorverpleegkundigen')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' Palliatieve zorg voor verpleegkundigen (o.a. Erasmus MC)');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'olposthboopleidingpz')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' (Post) HBO -opleiding palliatieve zorg');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'olanders')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' Anders');
  }
  ___arguments.context.pageData['uploadwoonplaatsen'] = ((getObjectProperty(___arguments.context.dataModel, 'pzwoonplaatsen')).split(','));
  ___arguments.context.pageData['listwoonplaatsen'] = ((getObjectProperty(___arguments.context.dataModel, 'pzwoonplaatsen')).split(','));
  ___arguments.context.pageData['listconsultatie'] = ((getObjectProperty(___arguments.context.dataModel, 'consultatie')).split(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/8f75cb21f7b6f5399af9744d6b446c6d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzconsultenvergoed')) == 'Ja') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['visible2'] = 'radio5';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzconsultenvergoed')) == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['visible2'] = 'radio6';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/c19e664817ac97325cd6abd9ec0d8b5e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgevolgdeopleidingen')) == 'Kaderopleiding palliatieve zorg') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['visible4'] = 'radio9';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgevolgdeopleidingen')) == 'Cardiff Palliative Medicine (post graduate)') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['visible4'] = 'radio10';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgevolgdeopleidingen')) == 'Cursus palliatieve zorg voor medisch specialisten') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['visible4'] = 'radio11';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgevolgdeopleidingen')) == '(Post) HBO -opleiding palliatieve zorg') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['visible4'] = 'radio12';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgevolgdeopleidingen')) == 'Opleiding (MSc) in een palliatieve zorgsetting') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['visible4'] = 'radio13';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgevolgdeopleidingen')) == 'Basisscholing palliatieve zorg') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['visible4'] = 'radio14';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgevolgdeopleidingen')) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d58117738c426ca6237d3a216c7918e9', false);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgevolgdeopleidingen')) != 'Kaderopleiding palliatieve zorg' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgevolgdeopleidingen')) != 'Cardiff Palliative Medicine (post graduate)' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgevolgdeopleidingen')) != 'Cursus palliatieve zorg voor medisch specialisten' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgevolgdeopleidingen')) != '(Post) HBO -opleiding palliatieve zorg' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgevolgdeopleidingen')) != 'Opleiding (MSc) in een palliatieve zorgsetting' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgevolgdeopleidingen')) != 'Basisscholing palliatieve zorg') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['visible4'] = 'radio15';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d58117738c426ca6237d3a216c7918e9', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d58117738c426ca6237d3a216c7918e9', false);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/3a8f249375135114c68bc19f060b0b42/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgegevensdelen')) == 'Ja') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['visible3'] = 'radio7';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'pzgegevensdelen')) == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['visible3'] = 'radio8';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/cadec8a5ccb56df2bacb7d7ad7758ce6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4919c578cedefe7288c67ccbd804c79d', (await Backendless.Data.of('consultatie').find(Backendless.DataQueryBuilder.create().setProperties(['consultatie', 'objectId']).setSortBy('nr ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/d89a480c077d25e6b0eae16c3927fdba/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/966c9bb6f51efb86a01f8fee77286d2f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = (getObjectProperty(___arguments.context.pageData, 'listconsultatie'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'consultatie')) == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/20351beb8244c7d198b4387fc9c5bb91/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzcaseload': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/9b4c65cf174a85416012735ac49e25ed/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzaantaljaarervaring': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/79a1280fe6c87c4f5f0dbb710e36e1a9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzopleidingsniveau': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/9fb67a69d316c4ff1d7700514274987a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzervaringscholing': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/5e7c81df96b11ffcc909115f73495cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzuitbreidingscholing': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/1d0dac451a21ed6754172136dc471869/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio9') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['pzgevolgdeopleiding'] = null;
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': 'Kaderopleiding palliatieve zorg' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio10') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['pzgevolgdeopleiding'] = null;
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': 'Cardiff Palliative Medicine (post graduate)' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio11') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['pzgevolgdeopleiding'] = null;
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': 'Cursus palliatieve zorg voor medisch specialisten' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio12') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['pzgevolgdeopleiding'] = null;
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': '(Post) HBO -opleiding palliatieve zorg' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio13') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['pzgevolgdeopleiding'] = null;
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': 'Opleiding (MSc) in een palliatieve zorgsetting' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio14') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['pzgevolgdeopleiding'] = null;
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': 'Basisscholing palliatieve zorg' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio13a') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['pzgevolgdeopleiding'] = null;
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': 'Palliatieve zorg voor verpleegkundigen (o.a. Erasmus MC)' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'visible4')) == 'radio15') {
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['pzgevolgdeopleidingen'] = null;
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'pzgevolgdeopleidingen': null }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/bb5bdb3d61f9a7ef5c99aae765359334/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2edfcd1d3dbc58aa1da7922118bac34f', (await Backendless.Data.of('woonplaats').find(Backendless.DataQueryBuilder.create().setProperties(['woonplaats', 'objectId']).setSortBy('woonplaats ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/360e57e48d44e123414b092ef555026b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), ' Zorgcoördinator');
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listfunctie')).splice((((getObjectProperty(___arguments.context.pageData, 'listfunctie')).indexOf(' Zorgcoördinator') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'functies': (getObjectProperty(___arguments.context.pageData, 'listfunctie')).join(','),'functiezorgcoordinator': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/2b2106bc6993f633c1d204e24167823b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), ' Consulent');
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listfunctie')).splice((((getObjectProperty(___arguments.context.pageData, 'listfunctie')).indexOf(' Consulent') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'functies': (getObjectProperty(___arguments.context.pageData, 'listfunctie')).join(','),'functieconsulent': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/25844715ca46f54d7ec94bf795061ed2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), ' Gespecialiseerd verpleegkundige');
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listfunctie')).splice((((getObjectProperty(___arguments.context.pageData, 'listfunctie')).indexOf(' Gespecialiseerd verpleegkundige') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'functies': (getObjectProperty(___arguments.context.pageData, 'listfunctie')).join(','),'functiegespecialiseerdverpleegkundige': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/563f14218aec559e481d31844ffc6683/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), ' Verpleegkundig specialist');
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listfunctie')).splice((((getObjectProperty(___arguments.context.pageData, 'listfunctie')).indexOf(' Verpleegkundig specialist') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'functies': (getObjectProperty(___arguments.context.pageData, 'listfunctie')).join(','),'functieverpleegkundigspecialist': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/5ee46fb16b18f2c91f28e3a277ab7459/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), ' Kaderarts palliatieve zorg');
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listfunctie')).splice((((getObjectProperty(___arguments.context.pageData, 'listfunctie')).indexOf(' Kaderarts palliatieve zorg') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'functies': (getObjectProperty(___arguments.context.pageData, 'listfunctie')).join(','),'functiekaderarts': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/760cd037c89a4f838096ce5609ca41d5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), ' Specialist ouderengeneeskunde');
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listfunctie')).splice((((getObjectProperty(___arguments.context.pageData, 'listfunctie')).indexOf(' Specialist ouderengeneeskunde') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'functies': (getObjectProperty(___arguments.context.pageData, 'listfunctie')).join(','),'functiespecialistouderengeneeskunde': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/13729a579b177e55a4ddfc8573890366/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), ' Internist');
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listfunctie')).splice((((getObjectProperty(___arguments.context.pageData, 'listfunctie')).indexOf(' Internist') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'functies': (getObjectProperty(___arguments.context.pageData, 'listfunctie')).join(','),'functieinternist': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/1af3b9da2fa1c0eb2461b7818323da9d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), ' Oncoloog');
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listfunctie')).splice((((getObjectProperty(___arguments.context.pageData, 'listfunctie')).indexOf(' Oncoloog') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'functies': (getObjectProperty(___arguments.context.pageData, 'listfunctie')).join(','),'functieoncoloog': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/ff836dcd05432f66a4c454b43943cc11/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), ' Klinische geriater');
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listfunctie')).splice((((getObjectProperty(___arguments.context.pageData, 'listfunctie')).indexOf(' Klinische geriater') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'functies': (getObjectProperty(___arguments.context.pageData, 'listfunctie')).join(','),'functieklinischegeriater': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/602efa2d79d51e947321e3557a8dd8b4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), ' Geestelijk verzorger');
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listfunctie')).splice((((getObjectProperty(___arguments.context.pageData, 'listfunctie')).indexOf(' Geestelijk verzorger') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'functies': (getObjectProperty(___arguments.context.pageData, 'listfunctie')).join(','),'functiegeestelijkverzorger': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/3ac449c35c6835865cf533621ba4bbb2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listfunctie')), ' Persoonlijk begeleider');
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listfunctie')).splice((((getObjectProperty(___arguments.context.pageData, 'listfunctie')).indexOf(' Persoonlijk begeleider') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listfunctie'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'functies': (getObjectProperty(___arguments.context.pageData, 'listfunctie')).join(','),'functiepersoonlijkbegeleider': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/363eb25d9ea7d7496592ef01e66b38cd/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = (getObjectProperty(___arguments.context.pageData, 'uploadwoonplaatsen'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'woonplaats')) == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/fbb7cb8ddfd61c2ca459d6d5cb4ce015/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' Basisscholing palliatieve zorg');
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).splice((((getObjectProperty(___arguments.context.pageData, 'listopleidingen')).indexOf(' Basisscholing palliatieve zorg') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'opleidingen': (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).join(','),'olbasisscholingpz': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/0a88cb61ecdab715531723816f85bedb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' Cardiff Palliative Medicine (post graduate)');
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).splice((((getObjectProperty(___arguments.context.pageData, 'listopleidingen')).indexOf(' Cardiff Palliative Medicine (post graduate)') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'opleidingen': (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).join(','),'olcardiffpalliativemedicine': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/cef8cc2f8cdc3f0654fa7fe710d1fa58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' Cursus palliatieve zorg voor medisch specialisten');
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).splice((((getObjectProperty(___arguments.context.pageData, 'listopleidingen')).indexOf(' Cursus palliatieve zorg voor medisch specialisten') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'opleidingen': (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).join(','),'olcursuspzvoormedischspecialisten': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/cfd804eb96e6e7173aadb7485b1fb498/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' Kaderopleiding palliatieve zorg');
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).splice((((getObjectProperty(___arguments.context.pageData, 'listopleidingen')).indexOf(' Kaderopleiding palliatieve zorg') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'opleidingen': (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).join(','),'olkaderopleidingpz': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/9e9d53247c99b1f104a787e31943043e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' Opleiding (MSc) in een palliatieve zorgsetting');
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).splice((((getObjectProperty(___arguments.context.pageData, 'listopleidingen')).indexOf(' Opleiding (MSc) in een palliatieve zorgsetting') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'opleidingen': (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).join(','),'olineenpalliatievezorgsetting': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/b989be7c39fb3471695f02dfacee3333/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' Palliatieve zorg voor verpleegkundigen (o.a. Erasmus MC)');
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).splice((((getObjectProperty(___arguments.context.pageData, 'listopleidingen')).indexOf(' Palliatieve zorg voor verpleegkundigen (o.a. Erasmus MC)') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'opleidingen': (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).join(','),'olpzvoorverpleegkundigen': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/2aae5f7c4b71b31376a5422ac968dc83/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' (Post) HBO -opleiding palliatieve zorg');
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).splice((((getObjectProperty(___arguments.context.pageData, 'listopleidingen')).indexOf(' (Post) HBO -opleiding palliatieve zorg') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'opleidingen': (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).join(','),'olposthboopleidingpz': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/5182261ce22d8d17350c31dbfcaa7ffe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listopleidingen')), ' Anders');
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).splice((((getObjectProperty(___arguments.context.pageData, 'listopleidingen')).indexOf(' Anders') + 1) - 1), 1);
    console.log(getObjectProperty(___arguments.context.pageData, 'listopleidingen'));
    await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'opleidinganders': null }) );
    ___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24')['opleidinganders'] = null;
  }
  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'opleidingen': (getObjectProperty(___arguments.context.pageData, 'listopleidingen')).join(','),'olanders': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/c3f64a9818350f9256addbf7b7e285e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevenszorgverleners').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'opleidinganders': String('Anders - ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5abdc7981537c8df863d094869669f24'), 'opleidinganders')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijnorganisatie/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijnorganisatie/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('gegevensorganisaties').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('gegevensorganisaties').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad76d327dd3d182c19f36f96773b0ab3', (await Backendless.Data.of('gegevensorganisaties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/mijnorganisatie/components/ad76d327dd3d182c19f36f96773b0ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad76d327dd3d182c19f36f96773b0ab3', (await Backendless.Data.of('gegevensorganisaties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijnorganisatie/components/5b2a824695749c17cb4da796cdfcecf5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'organisatie': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/f5596b12de2bd03f1ed94a43ef1138dd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'zelfevaluatiedatum': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/26867c7319fd485ef0c232bc8629c8b8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'relevanteprojectenpz': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/89463f99f17b52ab395fcf2b1ffdcfec/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'strategischbeleidsplantoelichting': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/ed88af373a0b981a864dcfecae347227/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible')) == 'radio1') {
    await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'strategischbeleidsplanaanwezig': 'Ja' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible')) == 'radio2') {
    await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'strategischbeleidsplanaanwezig': 'Nee' }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/2e829f71913e515f2ffa8f7b62262811/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible5')) == 'radio9') {
    await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'toestemminggegevensdelen': 'Ja' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible5')) == 'radio10') {
    await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'toestemminggegevensdelen': 'Nee' }) );
    await Backendless.Messaging.sendEmail('NPZ Arnhem geen toestemming om gegevens te delen', new Backendless.Bodyparts({ htmlmessage: (['<body>','Hallo Lorio','<body><br>',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),' heeft geen toestemming gegeven om gegevens te delen van de organisatie.','<br>','Kan je controleren of dit de bedoeling is geweest?','<body><br>','Met vriendelijke groet,','<body><br>','Lorio'].join('')) }), ensureArray('info@lorio.nl'), undefined);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/812858ccf49967a4cc4ae2c93639f6d3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible2')) == 'radio3') {
    await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'strategischbeleidsplanscholing': 'Ja' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible2')) == 'radio4') {
    await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'strategischbeleidsplanscholing': 'Nee' }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/49f47e1e5948b4f4a95954a69a9f5806/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'strategischbeleidsplanscholingtoelichting': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/dbdaca9f746305340dbb1c1c16a7875f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible3')) == 'radio5') {
    await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'geaccrediteerdescholingenaanbod': 'Ja' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible3')) == 'radio6') {
    await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'geaccrediteerdescholingenaanbod': 'Nee' }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/ef4817fb91a58bbf3192a861e79e5aa9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible4')) == 'radio7') {
    await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'zelfevaluatieuitgevoerd': 'Ja' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible4')) == 'radio8') {
    await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'zelfevaluatieuitgevoerd': 'Nee' }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/1b4a067b6f8dedc4a2d1844843d54aa7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'geaccrediteerdescholingenwelke': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/1e66544dd983736764a28d0c85ef53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'zelfevaluatietoelichting': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/bfecd155f05255ad805f50123ea1aa6b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'contactgegevensinkoop': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/6bc23db1316a3328b70d8261d178b2cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible3')) == 'radio5') {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible3')) == 'radio6') {
    visible = false;
    await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'geaccrediteerdescholingenwelke': null }) );
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['geaccrediteerdescholingenwelke'] = null;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijnorganisatie/components/07c478aa743c79db490441e7fb87c572/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible4')) == 'radio8') {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible4')) == 'radio7') {
    visible = false;
    await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'zelfevaluatiedatum': null }) );
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['zelfevaluatiedatum'] = null;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijnorganisatie/components/ad912732a3c5cf845ae7577515ede146/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'strategischbeleidsplanaanwezig')) == 'Ja') {
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible'] = 'radio1';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'strategischbeleidsplanaanwezig')) == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible'] = 'radio2';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijnorganisatie/components/fa6b9ed4f0b8a59ec21e0861fc126a4d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'strategischbeleidsplanscholing')) == 'Ja') {
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible2'] = 'radio3';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'strategischbeleidsplanscholing')) == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible2'] = 'radio4';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijnorganisatie/components/23377d62ba458a33f4685a1f14f1ea6c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'geaccrediteerdescholingenaanbod')) == 'Ja') {
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible3'] = 'radio5';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'geaccrediteerdescholingenaanbod')) == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible3'] = 'radio6';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijnorganisatie/components/0745ea224dc8406dc6612e4713717ccd/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'zelfevaluatieuitgevoerd')) == 'Ja') {
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible4'] = 'radio7';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'zelfevaluatieuitgevoerd')) == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible4'] = 'radio8';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijnorganisatie/components/fb2986b3a92f50b19229bcf387abd5ea/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'toestemminggegevensdelen')) == 'Ja') {
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible5'] = 'radio9';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'toestemminggegevensdelen')) == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3')['visible5'] = 'radio10';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijnorganisatie/components/5c515357dda54bd9a3074aa5ebfd0c05/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'naam': ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijnorganisatie/components/a10cac31fc1e11e95cb90b2b61443b0c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible6')) == 'radio11') {
    await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'scholingbinnenorganisatie': 'Ja' }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c968728943775263279da639985a68c3'), 'visible6')) == 'radio12') {
    await Backendless.Data.of('gegevensorganisaties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'scholingbinnenorganisatie': 'Nee' }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/notallowed/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/notallowed/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/npzhelpdesk/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/npzhelpdesk/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/npzhelpdesk/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/npzhelpdesk/components/71bb8c0f36a703f62f7844d46b446c8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('helpdesk', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`userrole`]: (await Backendless.UserService.getUserRoles()),[`vraag`]: (getObjectProperty(___arguments.context.pageData, 'email')) }), undefined);
  ___arguments.context.pageData['email'] = 'DE EMAIL IS VERZONDEN';
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/npzhoofdpagina/components/3144150ac571e5e7286c2d8fede7e428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/npzhoofdpagina/components/b4e8b57329ba9b3c520c9c2433d24fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/npzhoofdpagina/components/b1552a32f7853c686a04402fd58dcf95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijngegevens', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rolzorgverlener')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/npzhoofdpagina/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c1c67074bb2e68acf57fe679329ff30d', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/npzhoofdpagina/components/4a7870b61279d126f4c477f2dc77f1a1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('npzhelpdesk', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/npzhoofdpagina/components/6ffa3fabdc93a60b2e52b193771b2df3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijnorganisatie', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rolorganisatie')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/npzhoofdpagina/components/9ff3c6b37a2169a3fd3ffd6cc4056458/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'organisatie')) == null) {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/npzhoofdpagina/components/214c9c03dec84f6c876b0579c095b971/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'info@praktijk-bo.nl' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'info@lorio.nl' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/npzhoofdpagina/components/4ac80d9811881c58cf289f2323e2dae8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('permissions', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));
  await Backendless.Data.of('newuserrequests').bulkUpdate( 'objectId is not null', ({ [`aanmaken`]: false }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8daf5872d2777cc4a819fead57ce1b7', (await Backendless.Data.of('newuserrequests').find(Backendless.DataQueryBuilder.create().setWhereClause('useraangemaakt = 0').setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/permissions/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/67f403196da705f23d86dfac2267d69b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('Selecteer naam');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Selecteer email');
  } else if ((getObjectProperty(___arguments.context.pageData, 'usernameregister')) == null) {
    (function (message) { alert(message) })('Vul username in');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'pzcoach') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserpzcoach', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
      (function (message) { alert(message) })('De email is verzonden');
    } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'beheerder') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserbeheerder', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
      (function (message) { alert(message) })('De email is verzonden');
    } else {
      await Backendless.Messaging.sendEmailFromTemplate('newuserprojectleden', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
      (function (message) { alert(message) })('De email is verzonden');
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/3c46bf080591e52937d1171cdf247b5b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, k, beheerderslist, item, beheerders, j, declaratieslist, declaraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsdeclaratiesmnl() {
  users = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('objectId is not null') }).send());
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty(j, 'username')),'\''].join(''))) }).send());
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.REMOVE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('rol=\'beheerder\'') }).send());
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index in beheerderslist) {
        l = beheerderslist[l_index];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions declaraties uitgevoerd');
  (function (message) { alert(message) })('permissions declaraties uitgevoerd');
}


  await permissionsdeclaratiesmnl();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/d35d2ecc5053f5d217e97dd6aa67a7fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, m, gebruikersbeheerlist, item, gebruikersbeheer, userslist2, users2, j, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsgebruikersbeheer() {
  await Backendless.Data.of('gebruikersbeheer').bulkDelete( 'objectId is not null' );
  users = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users') }).send());
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    await Backendless.Data.of('gebruikersbeheer').save( ({ [`userobjectId`]: (getObjectProperty(j, 'objectId')),[`dashboardnaam`]: (getObjectProperty(j, 'dashboardnaam')),[`naam`]: (getObjectProperty(j, 'naam')),[`organisatie`]: (getObjectProperty(j, 'organisatie')),[`username`]: (getObjectProperty(j, 'username')),[`userStatus`]: (getObjectProperty(j, 'userStatus')),[`lastLogin`]: (getObjectProperty(j, 'lastLogin')),[`btwplichtig`]: (getObjectProperty(j, 'btwplichtig')),[`rol`]: (getObjectProperty(j, 'rol')),[`tariefkm`]: (getObjectProperty(j, 'tariefkm')),[`tariefuur`]: (getObjectProperty(j, 'tariefuur')),[`email`]: (getObjectProperty(j, 'email')) }) );
  }
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify((String('userStatus=\'ENABLED\'') + String(' AND rol = \'beheerder\''))) }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in userslist2) {
    l = userslist2[l_index];
    gebruikersbeheer = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('objectId is not null') }).send());
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('userStatus=\'ENABLED\'') }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index2 in userslist2) {
    l = userslist2[l_index2];
    gebruikersbeheer = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify((String('userStatus=\'ENABLED\'') + String(' AND rol = \'beheerder\''))) }).send());
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index2 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index2];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  await ZSD();
  console.log('permissions gebruikersbeheer uitgevoerd');
  (function (message) { alert(message) })('permissions gebruikersbeheer uitgevoerd');
}

/**
 * Describe this function...
 */
async function ZSD() {
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('username=\'Dnn73mwn\'') }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index3 in userslist2) {
    l = userslist2[l_index3];
    gebruikersbeheer = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('rol=\'ZSD\' OR rol=\'NCZSD\'') }).send());
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index3 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index3];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('rol=\'ZSD\' OR rol=\'NCZSD\'') }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index4 in userslist2) {
    l = userslist2[l_index4];
    gebruikersbeheer = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('username=\'Dnn73mwn\'') }).send());
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index4 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index4];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
}


  await permissionsgebruikersbeheer();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/a68db61433b22daeb3e3c9beb0d3c9b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, userslist2, item, users2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsusers() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': ' userStatus=\'ENABLED\'','properties': ['objectId'] }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in userslist2) {
    l = userslist2[l_index];
    await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
  console.log('permissions users uitgevoerd');
  (function (message) { alert(message) })('permissions users uitgevoerd');
}


  await permissionsusers();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/bfb66cb2f42e8afcf5b28649842d0c4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newuser, l, m, gebruikersbeheerlist, item, gebruikersbeheer, userslist2, users2, j, userslist, users, k, dossiers, declaraties;

/**
 * Describe this function...
 */
async function instellen_permissions() {
  await permissionsgebruikersbeheer();
  await permissionsusers();
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsgebruikersbeheer() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')),'properties': ['objectId', 'dashboardnaam', 'naam', 'organisatie', 'rol', 'username', 'userStatus', 'lastLogin', 'btwplichtig', 'btwinclondersteuningpatient', 'email'] }));
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    await Backendless.Data.of('gebruikersbeheer').save( ({ [`userobjectId`]: (getObjectProperty(j, 'objectId')),[`dashboardnaam`]: (getObjectProperty(j, 'dashboardnaam')),[`naam`]: (getObjectProperty(j, 'naam')),[`organisatie`]: (getObjectProperty(j, 'organisatie')),[`rol`]: (getObjectProperty(j, 'rol')),[`username`]: (getObjectProperty(j, 'username')),[`userStatus`]: (getObjectProperty(j, 'userStatus')),[`lastLogin`]: (getObjectProperty(j, 'lastLogin')),[`btwplichtig`]: (getObjectProperty(j, 'btwplichtig')),[`btwinclondersteuningpatient`]: (getObjectProperty(j, 'btwinclondersteuningpatient')),[`email`]: (getObjectProperty(j, 'email')) }) );
  }
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (String('userStatus=\'ENABLED\'') + String(' AND rol = \'beheerder\'')) }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in userslist2) {
    l = userslist2[l_index];
    gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': 'objectId is not null' }));
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  console.log('permissions gebruikersbeheer uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsusers() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')),'properties': ['objectId'] }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index2 in userslist2) {
    l = userslist2[l_index2];
    await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
  console.log('permissions users uitgevoerd');
}


  ___arguments.context.pageData['spinner'] = true;
  newuser = (await Backendless.UserService.register( new Backendless.User({ 'username': (getObjectProperty(___arguments.context.pageData, 'usernameregister')),'password': 'CVL2022isBegonnen!?','naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')),'rol': (getObjectProperty(___arguments.context.pageData, 'rol')),'btwplichtig': (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),'tariefpzcoachperuur': (getObjectProperty(___arguments.context.pageData, 'tariefpzcoachperuur')),'tariefdeclaratiesperuur': (getObjectProperty(___arguments.context.pageData, 'tariefdeclaratiesperuur')),'declaraties': (getObjectProperty(___arguments.context.pageData, 'declaraties')),'dossiers': (getObjectProperty(___arguments.context.pageData, 'dossiers')),'btwplichtig': (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),'btwinclondersteuningpatient': (getObjectProperty(___arguments.context.pageData, 'btwinclondersteuningpatient')) }) ));
  await instellen_permissions();
  (function (message) { alert(message) })((['User is geregistreerd: \n',['Username:  ',(getObjectProperty(newuser, 'username')),' \n'].join(''),['Naam: ',(getObjectProperty(newuser, 'naam')),' \n'].join(''),['Email:  ',(getObjectProperty(newuser, 'email')),' \n'].join(''),['Rol:  ',(getObjectProperty(newuser, 'rol')),' \n'].join('')].join('')));
  await Backendless.Data.of('newuserrequests').bulkUpdate( (['naam=\'',(getObjectProperty(newuser, 'naam')),'\''].join('')), ({ [`useraangemaakt`]: true }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8daf5872d2777cc4a819fead57ce1b7', (await Backendless.Data.of('newuserrequests').find(Backendless.DataQueryBuilder.create().setWhereClause('useraangemaakt = 0').setPageSize(10))));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/05ab59ac7c3b9157ad86d6a130cb67a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause('dashboardnaam NOT LIKE \'lorio%\'').setProperties('dashboardnaam').setSortBy('dashboardnaam DESC').setPageSize(10)))[0]), 'dashboardnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/permissions/components/9449ebc70bf23e2a1d64b969cf6647d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospice')) == 'Transfer bureau' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/permissions/components/543c1647fb91edcf0518d46c37752178/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, k, beheerderslist, item, beheerders, j, declaratieslist, declaraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsfacturatieadresgegevens() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': 'objectId is not null','properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'facturatieadresgegevens','whereClause': 'objectId is not null','properties': ['objectId'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': 'rol=\'beheerder\'' }));
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index in beheerderslist) {
        l = beheerderslist[l_index];
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions facturatieadresgegevens uitgevoerd');
  (function (message) { alert(message) })('permissions facturatieadresgegevens uitgevoerd');
}


  await permissionsfacturatieadresgegevens();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/6c3d7b18c98f6608c648ab78251bce44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, gegevenslist, item, gegevens, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsfactuurgegevens() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': 'objectId is not null','properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurgegevens','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId'] }));
    gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in gegevenslist) {
      k = gegevenslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions factuurgegevens uitgevoerd');
  (function (message) { alert(message) })('permissions factuurgegevens uitgevoerd');
}


  await permissionsfactuurgegevens();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/c3c8692edd7df313d0589228c22790e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  var j_list = ['naam', 'email', 'organisatie', 'usernameregister', 'btwplichtig', 'rol', null, null, null, null, null, null];
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.pageData[j] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/f8daf5872d2777cc4a819fead57ce1b7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8daf5872d2777cc4a819fead57ce1b7', (await Backendless.Data.of('newuserrequests').find(Backendless.DataQueryBuilder.create().setWhereClause('useraangemaakt = 0').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/permissions/components/7622db78b4a8b818b068046e27e81c18/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('newuserrequests').save( ___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58') );
  ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'naam'));
  ___arguments.context.pageData['email'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'email'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'organisatie'));
  ___arguments.context.pageData['rol'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'rol'));
  ___arguments.context.pageData['tariefdeclaratiesperuur'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'tariefdeclaratiesperuur'));
  ___arguments.context.pageData['tariefpzcoachperuur'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'tariefpzcoachperuur'));
  ___arguments.context.pageData['dossiers'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'dossiers'));
  ___arguments.context.pageData['declaraties'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'declaraties'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'btwplichtig'));
  ___arguments.context.pageData['btwinclondersteuningpatient'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'btwinclondersteuningpatient'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/permissions/components/7cef7da404088638c51e3a888e53ae58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, declaratieslist, item, declaraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsmaandafsluiten() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': 'rol=\'beheerder\'','properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'maandafsluiten','whereClause': 'objectId is not null','properties': ['objectId'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'maandafsluiten',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'maandafsluiten',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions maandafsluiten uitgevoerd');
  (function (message) { alert(message) })('permissions maandafsluiten uitgevoerd');
}


  await permissionsmaandafsluiten();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/57c849c81b7887b8300328298235b709/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log(await Backendless.UserService.findByRole('beheerder', false, Backendless.DataQueryBuilder.create().setPageSize(100)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/06ae39ec3388491b5458344b5f081e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, k, zsdbeheerderlist, item, zsdbeheerder, declaratieslist, declaraties, j, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsdeclaratieszsd() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': 'rol=\'ZSD\' or rol=\'NCZSD\'','properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaraties','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      zsdbeheerder = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': 'username=\'Dnn73mwn\'' }));
      zsdbeheerderlist = (await Promise.all(zsdbeheerder.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var m_index in zsdbeheerderlist) {
        m = zsdbeheerderlist[m_index];
        await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions declaraties ZSD uitgevoerd');
  (function (message) { alert(message) })('permissions declaraties ZSD uitgevoerd');
}


  await permissionsdeclaratieszsd();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/3848b36881a8b3d87de847a8dccb6618/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, k, beheerderslist, item, beheerders, declaratieslist, declaraties;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsdeclaratiesbeheerders() {
  declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaraties','whereClause': 'objectId is not null','properties': ['objectId'] }));
  declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var k_index in declaratieslist) {
    k = declaratieslist[k_index];
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': 'rol=\'beheerder\'' }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index in beheerderslist) {
      l = beheerderslist[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions declaraties beheerder uitgevoerd');
  (function (message) { alert(message) })('permissions declaraties beheerder uitgevoerd');
}


  await permissionsdeclaratiesbeheerders();

  },
  /* handler:onClick */
  /* content */
}))

